import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Save, MessageCircleQuestion } from "lucide-react";

export default function ConciergeLimitsPanel() {
  const [tiers, setTiers] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    api.get("/admin/concierge-limits").then(({ data }) => setTiers(data.tiers)).catch(() => setTiers([]));
  }, []);
  if (tiers === null) return <div className="flex justify-center py-6"><Loader2 className="w-5 h-5 animate-spin text-pb-red" /></div>;

  const setLimit = (tid, v) => setTiers(tiers.map((t) => t.tier_id === tid ? { ...t, limit: v === "" ? null : Number(v) } : t));
  const save = async () => {
    setSaving(true);
    try {
      const limits = {};
      tiers.forEach((t) => { if (t.limit !== null && t.limit !== undefined && t.limit !== "") limits[t.tier_id] = t.limit; });
      await api.put("/admin/concierge-limits", { limits });
      toast.success("Concierge limits saved — applies immediately");
    } catch { toast.error("Couldn't save limits"); }
    setSaving(false);
  };

  return (
    <div data-testid="concierge-limits-panel">
      <p className="text-xs text-zinc-500 mb-3 flex items-center gap-1.5">
        <MessageCircleQuestion className="w-3.5 h-3.5 text-pb-cyan" />
        Daily questions per member for the green Bullpen AI concierge. Leave blank = unlimited. New membership cards you add show up here automatically.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 mb-3">
        {tiers.map((t) => (
          <div key={t.tier_id} className="flex items-center gap-2 border border-pb-border px-3 py-2">
            <span className="text-xs font-bold uppercase tracking-wider text-zinc-300 flex-1 truncate">{t.name}</span>
            <input data-testid={`concierge-limit-${t.tier_id}`} type="number" min="0" placeholder="∞"
              value={t.limit ?? ""} onChange={(e) => setLimit(t.tier_id, e.target.value)}
              className="w-16 bg-pb-elevated border border-pb-border px-2 py-1 text-right text-xs text-white focus:border-pb-red outline-none" />
            <span className="text-[9px] uppercase tracking-widest text-zinc-600">/day</span>
          </div>
        ))}
      </div>
      <button data-testid="concierge-limits-save" disabled={saving} onClick={save}
        className="flex items-center gap-1.5 bg-pb-red text-black text-[10px] font-black uppercase tracking-widest px-4 py-2 hover:bg-[#BEF264] transition-colors disabled:opacity-50">
        <Save className="w-3.5 h-3.5" /> {saving ? "Saving…" : "Save Limits"}
      </button>
    </div>
  );
}
